import PropTypes from "prop-types";
import { DatePicker } from "components/DatePicker";
import { useDatepickerErrorState } from "hooks/datepicker/useDatepickerErrorState";

/**
 * A date picker for selecting the start date
 * @param startDate the currently selected start date
 * @param endDate the currently selected end date
 * @param onChange the function to call when a new start date is selected
 * @param label optional label, defaults to "Date from"
 * @param datePickerParams any other material ui date picker parameters
 * @returns {JSX.Element} a date picker
 */
export const StartDatePicker = ({
  startDate,
  endDate,
  onChange,
  label = "Date from",
  ...datePickerParams
}) => {
  const { setError, errorMessage } = useDatepickerErrorState();

  return (
    <DatePicker
      id="start-date-input"
      data-qa="AP-Date-Picker-Start-Date"
      label={label}
      date={startDate}
      onChange={onChange}
      onError={error => setError(error)}
      helperText={errorMessage}
      disableFuture
      //don't allow the user to select above the end date
      maxDate={endDate ?? undefined}
      //focus on the end date if a date isn't selected
      initialFocusedDate={endDate}
      //close the date picker when a date is selected
      ariaLabel="change start date"
      {...datePickerParams}
    />
  );
};

StartDatePicker.propTypes = {
  /** The currently selected start date */
  startDate: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.instanceOf(Date),
    PropTypes.string
  ]),
  /** The currently selected end date */
  endDate: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.instanceOf(Date),
    PropTypes.string
  ]),
  /** The function to call when a new start date is selected */
  onChange: PropTypes.func,
  /** The label of to display in the input */
  label: PropTypes.string
};
